import { Injectable } from '@angular/core';
import { ApiService } from './apiService.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { NgxSpinnerService } from "ngx-spinner";
import { secureStorage } from './encryption/secureservice';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  productsList: any
  filterList: any = []
  wishList:any[]=[]
  pl_name:any;
  sub: Subscription = new Subscription
  centerBanners: any;
  bannerList:any= [];
  compareVehicleOne:any= [];
  compareVehicleTwo:any= [];
  compareVehicleThree:any= [];
  tabSelected :any =[]
  constructor(
    private apiService: ApiService,
      private toastrService: ToastrService,private localStorage: secureStorage,
      private spinner: NgxSpinnerService) { }



  async getBannerList(lob?:any){
    let req;
    if(lob){
       req = {
        page: "EXPLORE",
        offset: 0,
        size: 3,
        lob:lob
      }
    }
    else{
    req = {
      page: "HOME",
      offset: 0,
      size: 6,
    }
    }

    await this.sub.add(this.apiService.getBannerListNew(req).subscribe({
      next: (response: any) => {

        if (response.success) {
          this.spinner.hide();
          this.bannerList = response.data;
          return this.bannerList;
        }
            else {
              this.spinner.hide();
              this.bannerList = [];
              if (response?.data?.msg == "User is not registered."){
              this.toastrService.warning(response.data.msg || response.msg)
              }
              else{
                this.bannerList = [];
                this.spinner.hide();


              }
              return this.bannerList;

            }
          },
          error: () => {
            this.toastrService.warning("Something went wrong!")

            this.spinner.hide();
            return this.bannerList;

          },
          complete: () => {

          }
        }))
      }

      replaceUnicode(input: string){
        // input.replace(/[^\x00-\x7F]/,"")
        return input?.replace(/[\u{0080}-\u{FFFF}]/gu,"")
      }

      showBreadCrumbb(page) {
        localStorage.removeItem('localBreadCrumb');
       let breadcrumbdata = [];

 let breadcrumbList: { label: any; url: string; pageName: string; };
        breadcrumbList = {
          label: 'Accounts',
          url: `account/profilePage`,
          pageName: 'profile page',
        };
        breadcrumbdata.push(breadcrumbList);

        breadcrumbList = {
          label: page,
          url: ``,
          pageName: page,

        };


        breadcrumbdata.push(breadcrumbList);

        this.localStorage.setItem('localBreadCrumb', JSON.stringify(breadcrumbdata));
        // this.showBreadCrumb = true;
        // this.breadCrumb?.getBreadCrumb()
        return  breadcrumbdata
      }

}

